import {
  IonCol,
  IonGrid,
  IonImg,
  IonItem,
  IonList,
  IonRow,
  IonText
} from "@ionic/react";
import { useState } from "react";

import { createNavigationProps } from "@/utils/common";
import {
  CONTACT_US_MENU_ITEM,
  EVERYTHING_YOU_NEED_MENU_ITEM,
  FAQ_MENU_ITEM,
  GET_STARTED_MENU_ITEM,
  LOGIN_MENU_ITEM,
  PREMIUM_FEATURES_MENU_ITEM,
  PRICING_MENU_ITEM,
  PRIVACY_POLICY_MENU_ITEM,
  TERMS_OF_USE_MENU_ITEM,
} from "@/utils/constants/menu";
import "./Footer.css";
// eslint-disable-next-line max-lines-per-function
function Footer() {
  const [thisYear, _y] = useState(new Date().getFullYear());
  return (
    <IonGrid data-testid="FooterGrid" className="footer">
      <IonRow className="ion-justify-content-between">
        <IonCol sizeMd="3" sizeXs="12">
          <h2 className="title ion-no-padding">Features</h2>
          <IonList lines="none" className="ion-no-padding">
            <IonItem
              className="ion-no-padding"
              {...createNavigationProps(PREMIUM_FEATURES_MENU_ITEM.linkTo)}
            >
              <IonText className="premium ion-no-padding">
                {PREMIUM_FEATURES_MENU_ITEM.label}
              </IonText>
            </IonItem>
            <IonItem
              className="ion-no-padding"
              {...createNavigationProps(EVERYTHING_YOU_NEED_MENU_ITEM.linkTo)}
            >
              <IonText>Maintenance Intelligence</IonText>
            </IonItem>
            <IonItem
              className="ion-no-padding"
              {...createNavigationProps(EVERYTHING_YOU_NEED_MENU_ITEM.linkTo)}
            >
              <IonText>Weight and Balance</IonText>
            </IonItem>
            <IonItem
              className="ion-no-padding"
              {...createNavigationProps(EVERYTHING_YOU_NEED_MENU_ITEM.linkTo)}
            >
              <IonText>Engine Trending</IonText>
            </IonItem>
          </IonList>
        </IonCol>
        <IonCol sizeMd="3" sizeXs="12">
          <h2 className="title ion-no-padding">Get Started</h2>
          <IonList lines="none" className="ion-no-padding">
            <IonItem
              className="ion-no-padding"
              {...createNavigationProps(GET_STARTED_MENU_ITEM.linkTo)}
            >
              <IonText className="premium">Start Your Free Trial</IonText>
            </IonItem>
            <IonItem
              className="ion-no-padding"
              {...createNavigationProps(PRICING_MENU_ITEM.linkTo)}
            >
              <IonText>{PRICING_MENU_ITEM.label}</IonText>
            </IonItem>
            <IonItem
              className="ion-no-padding"
              {...createNavigationProps(FAQ_MENU_ITEM.linkTo)}
            >
              <IonText>{FAQ_MENU_ITEM.label}</IonText>
            </IonItem>
          </IonList>
        </IonCol>
        <IonCol sizeMd="3" sizeXs="12">
          <h2 className="title ion-no-padding">Account</h2>
          <IonList lines="none" className="ion-no-padding">
            <IonItem
              className="ion-no-padding"
              {...createNavigationProps(LOGIN_MENU_ITEM.linkTo)}
            >
              <IonText>Have a Code?</IonText>
            </IonItem>
            <IonItem
              className="ion-no-padding"
              {...createNavigationProps(LOGIN_MENU_ITEM.linkTo)}
            >
              <IonText>{LOGIN_MENU_ITEM.label}</IonText>
            </IonItem>
            <IonItem
              className="ion-no-padding"
              {...createNavigationProps(CONTACT_US_MENU_ITEM.linkTo)}
            >
              <IonText>{CONTACT_US_MENU_ITEM.label}</IonText>
            </IonItem>
          </IonList>
        </IonCol>
      </IonRow>
      <IonRow
        data-testid="FooterBrandRow"
        className="footer-brand-row ion-justify-content-between"
      >
        <IonCol sizeMd="2" sizeXs="12">
          <IonRow className="ion-justify-content-start">
            <IonImg
              data-testid="FooterLogo"
              src="mFP_icon.png"
              className="logo"
            />
          </IonRow>
        </IonCol>
        <IonCol sizeMd="3" sizeXs="12">
          <IonRow className="ion-justify-content-end">
            <IonCol>
              <IonItem
                className="ion-no-padding"
                lines="none"
                {...createNavigationProps(TERMS_OF_USE_MENU_ITEM.linkTo)}
              >
                <IonText>{TERMS_OF_USE_MENU_ITEM.label}</IonText>
              </IonItem>
            </IonCol>
            <IonCol>
              <IonItem
                className="ion-no-padding"
                lines="none"
                {...createNavigationProps(PRIVACY_POLICY_MENU_ITEM.linkTo)}
              >
                <IonText>{PRIVACY_POLICY_MENU_ITEM.label}</IonText>
              </IonItem>
            </IonCol>
          </IonRow>
        </IonCol>
      </IonRow>
      <IonRow>
        <IonText>© {thisYear} myFirePlane all rights reserved.</IonText>
      </IonRow>
    </IonGrid>
  );
}

export { Footer };
